import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Faq, FaqSection, IFaqSection } from '../../../classes/http-responses';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'faq-category',
	template: require('./faq-category.component.html'),
})
export class FaqCategoryComponent implements OnChanges {
	@Input() section: IFaqSection;
	public isRebrading = AppSettings.isRebrading;

	public searchResults: Faq[];
	public searchTerm: string;
	public isExpanded: boolean[] = [false];
	private _sectionDataModel: FaqSection;

	public ngOnChanges(simpleChanges: SimpleChanges): void {
		this._sectionDataModel = new FaqSection(this.section);
		this.isExpanded = [false];
		this.setSearch(null);
		if (this._sectionDataModel.title === 'Video Tutorials') {
			this.setExpandedAnsw();
		}
	}

	public setSearch(term: string) {
		this.searchResults = this._sectionDataModel.search(term);
	}

	public toggleQuestion(i: number) {
		this.isExpanded[i] = !this.isExpanded[i];
	}

	private setExpandedAnsw() {
		this._sectionDataModel.faqs.forEach((i) => {
			if (i.sortOrder === 1) {
				this.isExpanded[i.sortOrder - 1] = true;
			}
		});
	}
}
